import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Header/Main';
import Banner from '../Menhome/Banner';
import Keyfeature from '../Menhome/Keyfeature';
import Aboutus from '../Menhome/Aboutus';
import TextList from '../Menhome/TextList';
import Service from '../Menhome/Service';
import HowWork from '../Menhome/HowWork';
import Review from '../Menhome/Review';
import Interface from '../Menhome/Interface';
import Text from '../Menhome/Text';
import Blog from '../Menhome/Blog';
import Footer from '../Footer/Main';
import Aos from 'aos';
import Faq from '../Menhome/Faq';
import ScrollTracker from '../ScrollTracker';
import { ROUTE_TO_SECTION } from '../../routes';

function Main() {
  const { pathname } = useLocation();

  useEffect(() => {
    Aos.init();
    Aos.refresh();
  }, []);

  useEffect(() => {
    const sectionId = ROUTE_TO_SECTION[pathname];
    if (!sectionId) return;

    const scrollToSection = () => {
      const el = document.getElementById(sectionId);
      if (!el) return false;
      const y = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      return true;
    };

    const run = () => {
      if (!scrollToSection()) {
        setTimeout(scrollToSection, 300);
      }
    };

    const alreadyLoaded = document.readyState === 'complete';
    if (alreadyLoaded) {
      requestAnimationFrame(() => requestAnimationFrame(run));
    } else {
      window.addEventListener(
        'load',
        () => {
          requestAnimationFrame(() => requestAnimationFrame(run));
        },
        { once: true },
      );
    }
  }, [pathname]);

  return (
    <>
      <ScrollTracker />
      <Header />
      <Banner />
      <Keyfeature />

      <Aboutus />
      <TextList />
      <Service />
      {/* <HowWork /> */}
      <Review />
      <Faq />
      <Interface />
      <Text />
      {/* <Blog /> */}
      <Footer />
    </>
  );
}

export default Main;
